/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Container, Grid, Segment, Header, Card, Table, Button, Search, List, Message,
  Popup,
} from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

import { getUserDisplayNameFromEmail } from '../../../helpers/format';
import { base } from '../../../config/constants';
import { AlertBox, ConfirmBox, SelectBox, askConfirmation, setAlertMsg, pickOne } from '../../../components/Modals';

export default class EditRecipient extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    match: PropTypes.object,
  }

  static defaultProps = {
    habilitations: { uid: null },
    match: { params: {} },
    history: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedRecipient: null,
      selectedRecipientId: null,
      recipientsLoading: true,
      selectedRecipientLoading: !!props.match.params.id,
      recipients: [],
      search: {
        isLoading: false,
        value: '',
        results: [],
      },
      adding: {
        themes: false,
        citizenly: false,
        elected: false,
      },
    };
  }

  componentDidMount() {
    this._ismounted = true;
    // console.log('did mount ', this.props);
    base.bindToState('users', {
      context: this,
      state: 'recipients',
      asArray: true,
      queries: {
        orderByChild: 'email',
        startAt: '',
      },
      then: () => this.setState({ recipientsLoading: false }),
    });
    if (this.props.match.params.id) {
      this.selectedBinding = base.bindToState(`users/${this.props.match.params.id}`, {
        context: this,
        state: 'selectedRecipient',
        then: () => this.setState({ selectedRecipientLoading: false, selectedRecipientId: this.props.match.params.id }),
      });
    }
  }

  componentWillUnmount() {
    this._ismounted = false;
    clearTimeout(this.timeOutForSearchChange);
  }

  getFormattedList = (themeType) => {
    let wordNone;
    let current;
    switch (themeType) {
      case 'themes':
        wordNone = 'Aucune profession';
        current = 'currentTheme';
        break;
      case 'citizenly':
        wordNone = 'Aucune commune';
        current = 'currentCitizenly';
        break;
      case 'elected':
        wordNone = 'Aucune circonscription';
        current = 'currentElected';
        break;
      default:
        wordNone = '-';
        current = 'none';
        break;
    }
    if (
      !themeType
      || !this.state.selectedRecipient
      || !this.state.selectedRecipient) {
      return '';
    }
    const currentThemeEntity = current;
    const matchAgainstCurrent = this.state.selectedRecipient[currentThemeEntity] || null;
    // console.log(matchAgainstCurrent);
    if (this.state.selectedRecipient.fullAccess && this.state.selectedRecipient.fullAccess[themeType]
      && !this.props.habilitations.superuser && !this.state.selectedRecipient[themeType]) {
      return 'Accès total activé';
    }

    if (this.props.habilitations.superuser && !this.state.selectedRecipient[themeType]) {
      return null;
    }

    if (
      !themeType
      || !this.state.selectedRecipient
      || !this.state.selectedRecipient
      || !this.state.selectedRecipient[themeType]
    ) {
      return wordNone;
    }

    const themes = Object.keys(this.state.selectedRecipient[themeType]);
    return (
      <List>
        {
          _.map(themes, item => (
            <List.Item key={item}>
              <List.Content>
                <Popup trigger={
                  <Button
                    fluid
                    animated="fade"
                    color={item === matchAgainstCurrent ? 'green' : 'blue'}
                    compact
                    size="tiny"
                    onClick={() => this.handleDeleteThemeAccess(themeType, item, this.state.selectedRecipientId)}
                  >
                    <Button.Content visible>
                      {item.toUpperCase()}
                    </Button.Content>
                    <Button.Content hidden>
                      Supprimer
                    </Button.Content>
                  </Button>
                }
                >
                  {
                    item === matchAgainstCurrent
                      ? 'Ce destinataire est habilité et reçoit les alertes.'
                      : 'Destinataire habilité mais ne reçoit pas ou ne reçoit plus les alertes.'
                  }
                </Popup>

              </List.Content>
            </List.Item>
          ))
        }
      </List>
    );
  };

  selectedBinding;
  timeOutForSearchChange;
  _ismounted = false;

  handleResultSelect = (e, { result }) => {
    // console.log(result);
    // this.setState({ search: { ...this.state.search, value: result.title } });
    this.props.history.push(`/recipients/edit/${result.key}`);
  };

  handleToggleSuperuser = (recipientId, trueIfActivateRequest, themeType) => {
    let wordNone;
    switch (themeType) {
      case 'themes':
        wordNone = 'toutes les professions';
        break;
      case 'citizenly':
        wordNone = 'toutes les communes';
        break;
      case 'elected':
        wordNone = 'toutes les circonscriptions';
        break;
      default:
        wordNone = '-';
        break;
    }
    this.setState(askConfirmation(
      trueIfActivateRequest ? `Activer l'accès à  ${wordNone}?` : `Retirer l'accès à  ${wordNone}?`,
      trueIfActivateRequest
        ? `L'utilisateur <strong>${this.state.selectedRecipient.email}</strong> pourra consulter les messages envoyés à ${wordNone}.
        <br/><br/>Voulez-vous vraiment lui donner cet accès ?`
        : `L'utilisateur <strong>${this.state.selectedRecipient.email}</strong> ne pourra plus consulter les messages envoyés à ${wordNone}.
        <br/><br/>Voulez-vous vraiment lui retirer cet accès" ?`,
      trueIfActivateRequest ? 'warn' : 'neutral',
      () => {
        if (trueIfActivateRequest) {
          base.update(`users/${recipientId}/fullAccess`, { data: { [themeType]: true } }).catch((error) => {
            this.setState(setAlertMsg(error.code || null, 'Impossible de donner l\'accès', error.toString(), 'error'));
          });
        } else {
          base.remove(`users/${recipientId}/fullAccess/${themeType}`).catch((error) => {
            this.setState(setAlertMsg(error.code || null, 'Impossible de retirer l\'accès', error.toString(), 'error'));
          });
        }
      },
      trueIfActivateRequest ? 'OUI, ACTIVER' : 'OUI, RETIRER',
    ));
  }

  handleAddThemeAccess = (themeType, recipientId) => {
    if (recipientId !== this.state.selectedRecipientId) {
      return false;
    }
    this.setState({ adding: { ...this.state.adding, [themeType]: true } });
    // console.log('handleAddThemeAccess', themeType, recipientId, { adding: { ...this.state.adding, [themeType]: true } });
    // console.log(this.state);

    let word;
    switch (themeType) {
      case 'themes':
        word = 'une profession';
        break;
      case 'citizenly':
        word = 'une commune';
        break;
      case 'elected':
        word = 'une circonscription';
        break;
      default:
        word = '';
        break;
    }

    return base.fetch(`${themeType}`, {
      context: this,
      asArray: true,
    }).then((data) => {
      // console.log(data);
      const options = _.filter(_.map(data, source => ({
        key: source.key,
        value: source.key,
        text: `${source.nom} (${source.key})`,
      })), el => this.props.habilitations.superuser || this.props.habilitations[themeType][el.key]);
      this.setState({
        ...pickOne(
          `Ajouter ${word}`,
          `Vous souhaitez ajouter un abonnement au destinataire suivant:<br/>
           <strong>${this.state.selectedRecipient.email}</strong>.<br/><br/>
           Pour cela, veuillez choisir ${word} dans la liste ci-dessous puis cliquer sur "Ajouter" :`,
          'create',
          (themeId) => {
            base.update(`users/${recipientId}/${themeType}`, { data: { [themeId]: true } }).catch((error) => {
              this.setState(setAlertMsg(
                error.code || null,
                'Impossible d\'ajouter l\'abonnement',
                error.toString(),
                'error',
              ));
            });
          },
          options,
          'Ajouter',
          `Sélectionnez ${word}`,
        ),
        adding: { ...this.state.adding, [themeType]: false },
      });
    }).catch((error) => {
      this.setState({
        ...setAlertMsg(error.code || null, 'Impossible de récupérer la liste', error.toString(), 'error'),
        adding: { ...this.state.adding, [themeType]: false },
      });
    });
  }

  handleDeleteThemeAccess = (themeType, themeId, recipientId) => {
    let word;
    switch (themeType) {
      case 'themes':
        word = 'la profession ';
        break;
      case 'citizenly':
        word = 'la commune ';
        break;
      case 'elected':
        word = 'la circonscription de ';
        break;
      default:
        word = '';
        break;
    }
    return this.setState(askConfirmation(
      `Retirer l'abonnement à ${word} ?`,
      `L'utilisateur <strong>${this.state.selectedRecipient.email}</strong> ne pourra plus recevoir les messages destinés à ${word}<strong>${themeId.toUpperCase()}</strong><br/><br/>Voulez-vous vraiment lui retirer cet abonnement ?`,
      'warn',
      () => {
        base.remove(`users/${recipientId}/${themeType}/${themeId}`).catch((error) => {
          this.setState(setAlertMsg(
            error.code || null,
            'Impossible de retirer l\'abonnement',
            error.toString(),
            'error',
          ));
        });
      },
      'OUI, RETIRER',
    ));
  }


  handleSearchChange = (e, { value }) => {
    this.setState({ search: { ...this.state.search, isLoading: true, value } });


    this.timeOutForSearchChange = setTimeout(() => {
      // if (this.state.search.value.length < 1) return this.resetSearchComponent();
      if (value.length < 1) return this.resetSearchComponent();

      const re = new RegExp(_.escapeRegExp(this.state.search.value), 'i');
      const isMatch = result => re.test(result.email);
      const map = {
        key: 'userid',
      };
      if (!this._ismounted) return true;
      this.setState({
        search: {
          ...this.state.search,
          isLoading: false,
          results: _.map(_.filter(this.state.recipients, isMatch), a => _.reduce(a, (result, v, key) => {
            // eslint-disable-next-line no-param-reassign
            result[key.toLowerCase()] = v;
            if (map[key]) {
              // eslint-disable-next-line no-param-reassign
              result[map[key]] = v;
            }
            // console.log(result);
            return result;
          }, {})),
        },
      });
      return true;
    }, 100);
  }


  resetSearchComponent = () => this.setState({ search: { isLoading: false, results: [], value: '' } });

  render() {
    // console.log(this.props.habilitations);
    // console.log(this.state.selectedRecipient);
    const noneSelected = this.state.selectedRecipient === null;
    // const selfIsSelected = !noneSelected && this.state.selectedRecipientId === this.props.habilitations.uid;
    const habObject = noneSelected ? {} : (this.state.selectedRecipient || {});
    const recipient = this.state.selectedRecipient;

    if (
      this.props.match.params.id && !this.state.recipientsLoading && !this.state.selectedRecipientLoading
      && (noneSelected || !this.state.selectedRecipient.email)
    ) {
      return <Redirect to="/access-mgt/view" />;
    }

    return (
      <Container>
        <Segment basic loading={this.state.recipientsLoading}>
          <Grid columns={2}>

            <Grid.Column width={6}>
              <Grid.Row>
                <Segment textAlign="center" basic>
                  <Header textAlign="center" size="small">
                    Sélectionnez un destinataire
                  </Header>
                  <Search
                    fluid
                    selectFirstResult
                    input={{ autoFocus: true }}
                    noResultsMessage={this.state.search.isLoading ? 'Recherche en cours' : 'Aucun résultat'}
                    noResultsDescription="Évitez les accents et caractères spéciaux."
                    onResultSelect={this.handleResultSelect}
                    onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                    loading={this.state.search.isLoading}
                    results={this.state.search.results}
                    value={this.state.search.value}
                    resultRenderer={({ email }) => (
                      <div>
                        <Header size="small">
                          {getUserDisplayNameFromEmail(email)}
                        </Header>
                        {email}
                      </div>
                    )}
                  />
                  {noneSelected ? (
                    <Message compact info>
                      Utilisez le champ de recherche ci-dessus pour sélectionner le destinataire dont
                      vous souhaitez éditer les abonnements.
                    </Message>
                  ) : (
                    <Message compact>
                      Vous pouvez utiliser ce champ de recherche pour afficher un autre destinataire.
                    </Message>
                  )}
                </Segment>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={10}>
              <Grid.Row>
                <Segment basic loading={!this.state.recipientsLoading && this.state.selectedRecipientLoading}>
                  <Card fluid raised={!noneSelected}>
                    <Card.Content>
                      <Card.Header
                        size="small"
                        content={
                          !noneSelected ?
                            getUserDisplayNameFromEmail(recipient.email) : 'Utilisez le champ de recherche à gauche.'
                        }
                      />
                      <Card.Meta
                        content={
                          !noneSelected ?
                            recipient.email : 'Aucun destinataire sélectionné'
                        }
                      />
                    </Card.Content>
                    <Card.Content>
                      <Card.Meta
                        content="Abonnements du destinataire sélectionné"
                      />
                      <Table definition={!noneSelected} color={!noneSelected ? 'blue' : null}>
                        <Table.Body>
                          <Table.Row disabled={noneSelected}>
                            <Table.Cell>Professionnels</Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.getFormattedList('themes')}
                              {this.props.habilitations.superuser ? (
                                <Button
                                  fluid
                                  animated="fade"
                                  color={
                                    noneSelected || !(habObject.fullAccess && habObject.fullAccess.themes)
                                      ? null : 'red'
                                  }
                                  disabled={noneSelected}
                                  onClick={
                                    () => noneSelected
                                      || this.handleToggleSuperuser(
                                        this.state.selectedRecipientId,
                                        !(habObject.fullAccess && habObject.fullAccess.themes),
                                        'themes',
                                      )
                                  }
                                >
                                  <Button.Content visible>
                                    {noneSelected
                                    || !(habObject.fullAccess && habObject.fullAccess.themes)
                                      ? 'Accès total désactivé' : 'Accès total activé'}
                                  </Button.Content>
                                  <Button.Content hidden>
                                    {noneSelected || !(habObject.fullAccess && habObject.fullAccess.themes)
                                      ? 'Activer' : 'Désactiver'}
                                  </Button.Content>
                                </Button>) : null
                              }
                            </Table.Cell>
                            <Table.Cell collapsing>
                              {(this.props.habilitations.superuser || this.props.habilitations.themes) ? (
                                <Popup
                                  trigger={
                                    <Button
                                      icon="add"
                                      color="green"
                                      inverted
                                      circular
                                      disabled={noneSelected}
                                      loading={this.state.adding.themes}
                                      onClick={
                                        () => noneSelected
                                          || this.handleAddThemeAccess('themes', this.state.selectedRecipientId)
                                      }
                                    />
                                  }
                                >
                                  <Popup.Content>Ajouter une profession</Popup.Content>
                                </Popup>
                              ) : null}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row disabled={noneSelected}>
                            <Table.Cell>Participation Citoyenne</Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.getFormattedList('citizenly')}
                              {this.props.habilitations.superuser ? (
                                <Button
                                  fluid
                                  animated="fade"
                                  color={
                                    noneSelected || !(habObject.fullAccess && habObject.fullAccess.citizenly)
                                      ? null : 'red'
                                  }
                                  disabled={noneSelected}
                                  onClick={
                                    () => noneSelected
                                      || this.handleToggleSuperuser(
                                        this.state.selectedRecipientId,
                                        !(habObject.fullAccess && habObject.fullAccess.citizenly),
                                        'citizenly',
                                      )
                                  }
                                >
                                  <Button.Content visible>
                                    {noneSelected
                                    || !(habObject.fullAccess && habObject.fullAccess.citizenly)
                                      ? 'Accès total désactivé' : 'Accès total activé'}
                                  </Button.Content>
                                  <Button.Content hidden>
                                    {noneSelected || !(habObject.fullAccess && habObject.fullAccess.citizenly)
                                      ? 'Activer' : 'Désactiver'}
                                  </Button.Content>
                                </Button>) : null
                              }
                            </Table.Cell>
                            <Table.Cell collapsing>
                              {!(habObject.citizenly && !this.props.habilitations.superuser)
                              && (this.props.habilitations.superuser || this.props.habilitations.citizenly) ? (
                                <Popup
                                  trigger={
                                    <Button
                                      icon="add"
                                      color="green"
                                      inverted
                                      circular
                                      disabled={noneSelected}
                                      loading={this.state.adding.citizenly}
                                      onClick={
                                        () => noneSelected
                                          || this.handleAddThemeAccess('citizenly', this.state.selectedRecipientId)
                                      }
                                    />
                                  }
                                >
                                  <Popup.Content>Ajouter une commune</Popup.Content>
                                </Popup>
                              ) : null}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row disabled={noneSelected}>
                            <Table.Cell>Contact Élus</Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.getFormattedList('elected')}
                              {this.props.habilitations.superuser ? (
                                <Button
                                  fluid
                                  animated="fade"
                                  color={
                                    noneSelected || !(habObject.fullAccess && habObject.fullAccess.elected)
                                      ? null : 'red'
                                  }
                                  disabled={noneSelected}
                                  onClick={
                                    () => noneSelected
                                      || this.handleToggleSuperuser(
                                        this.state.selectedRecipientId,
                                        !(habObject.fullAccess && habObject.fullAccess.elected),
                                        'elected',
                                      )
                                  }
                                >
                                  <Button.Content visible>
                                    {noneSelected
                                    || !(habObject.fullAccess && habObject.fullAccess.elected)
                                      ? 'Accès total désactivé' : 'Accès total activé'}
                                  </Button.Content>
                                  <Button.Content hidden>
                                    {noneSelected || !(habObject.fullAccess && habObject.fullAccess.elected)
                                      ? 'Activer' : 'Désactiver'}
                                  </Button.Content>
                                </Button>) : null
                              }
                            </Table.Cell>
                            <Table.Cell collapsing>
                              {!(habObject.elected && !this.props.habilitations.superuser)
                              && (this.props.habilitations.superuser || this.props.habilitations.elected) ? (
                                <Popup
                                  trigger={
                                    <Button
                                      icon="add"
                                      color="green"
                                      inverted
                                      circular
                                      disabled={noneSelected}
                                      loading={this.state.adding.elected}
                                      onClick={
                                        () => noneSelected
                                          || this.handleAddThemeAccess('elected', this.state.selectedRecipientId)
                                      }
                                    />
                                  }
                                >
                                  <Popup.Content>Ajouter une circonscription</Popup.Content>
                                </Popup>
                              ) : null}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Card.Content>
                  </Card>
                </Segment>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
        <SelectBox
          propagateClosure={() => this.setState({ pick: { open: false } })}
          {...this.state.pick}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/Recipients/EditRecipient.js